import React from 'react';
import PropTypes from 'prop-types';

import {Stack, IconButton, Typography} from 'views/components';
import {Translate} from 'views/module';
import BiographyQuestion from '../../BiographyQuestion';
import {Add, Delete} from 'views/icons';

const ContentView = (props) => {
  const {bioQuestion, getSignedFileUrl, updateQuestionData} = props;
  const {bioQuestionId, questionData: {value, schema}} = bioQuestion;

  const getDefaultValue = (fieldType) => {
    if (fieldType === 'checkbox') {
      return false;
    } else if (fieldType === 'five_star') {
      return 1;
    } else {
      return '';
    }
  };

  const updateItem = (idx, fieldKey, questionData) => {
    const questionDataFunc = (typeof questionData === 'function') ? questionData : () => questionData;

    updateQuestionData((prev) => {
      const newArr = [...prev.value];
      newArr[idx] = {
        ...prev.value[idx],
        [fieldKey]: questionDataFunc(prev.value[idx][fieldKey]),
      };

      return {
        value: newArr,
        schema: prev.schema,
      };
    });
  };

  const addItem = () => {
    updateQuestionData((prev) => {
      const newItem = Object.fromEntries(Object.entries(schema).map(([fieldKey, fieldType]) => [fieldKey, {value: getDefaultValue(fieldType)}]));
      const newValue = [...prev.value, newItem];

      return {
        value: newValue,
        schema: prev.schema,
      };
    });
  };

  const removeItem = (idx) => {
    updateQuestionData((prev) => {
      const newValue = [...prev.value];
      newValue.splice(idx, 1);

      return {
        value: newValue,
        schema: prev.schema,
      };
    });
  };

  return (
    <Stack
      position='relative'
      sx={{
        'padding': 2,
        'border': '1px solid rgba(0,0,0, 0.23)',
        'borderRadius': '4px',
        'width': '100%',
      }}
      gap={2}
    >
      <Typography
        sx={{
          position: 'absolute',
          backgroundColor: 'white',
          top: 0,
          left: 0,
          transform: 'translate(-5%, -50%) scale(0.75)',
          color: 'rgba(0,0,0,0.6)',
          px: 1,
        }}
      >
        <Translate expression={`caregiver.CaregiverDetail.Biography.Questions.Titles.${bioQuestionId}`} />
      </Typography>
      <Stack
        gap={4}
      >
        {
          value.map((question, idx) => (
            <Stack
              key={idx}
              gap={1}
            >
              <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Typography fontWeight='bold'>
                  <Translate expression={`caregiver.CaregiverDetail.Biography.Questions.Titles.${bioQuestionId}`} /> {idx+1}
                </Typography>
                <IconButton onClick={() => removeItem(idx)}>
                  <Delete />
                </IconButton>
              </Stack>
              {
                Object.entries(schema).map(([fieldKey, fieldType]) => {
                  const pseudoQuestion = {
                    bioQuestionId: `${bioQuestionId}_${fieldKey}`,
                    fieldType,
                    questionData: question[fieldKey],
                  };
                  return (
                    <BiographyQuestion
                      key={fieldKey}
                      mode='EDIT'
                      bioQuestion={pseudoQuestion}
                      updateQuestionData={(questionData) => updateItem(idx, fieldKey, questionData)}
                      caregiverBackend={{
                        bioQuestions: {getSignedFileUrl},
                        detail: {editPhotoUrl: () => undefined},
                      }}
                      subQuestion
                    />
                  );
                })
              }
            </Stack>
          ))
        }
      </Stack>
      <Stack
        direction={'row'}
        sx={{
          justifyContent: 'center',
        }}
      >
        <IconButton onClick={addItem} >
          <Add />
        </IconButton>
      </Stack>
    </Stack>
  );
};

ContentView.propTypes = {
  bioQuestion: PropTypes.shape({
    bioQuestionId: PropTypes.string.isRequired,
    questionData: PropTypes.shape({
      value: PropTypes.array.isRequired,
      schema: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
  getSignedFileUrl: PropTypes.func.isRequired,
  updateQuestionData: PropTypes.func.isRequired,
};

export default ContentView;
